module.exports = __webpack_public_path__ + "img/ic_pause.ae9139dc.svg";